export const getBraintreeMerchantAccountStatusLabelFlags = (
  status?: string,
) => ({
  deleted: status === 'SUSPENDED',
  error: status === 'Sync.Error',
  success: status === 'ACTIVE',
  warning: status !== 'PENDING',
})
